import Q from "q";
import axios from "axios";
import httpTools from "./httpTools";
import store from "Store";
import { getMedium, getOS } from "Services/utils/index";
import Cookies from "universal-cookie";
import Locale from "Services/locale";

let call;

const Customer = (() => {
    const baseUrl = httpTools.envUrls();
    const baseUrlLive = httpTools.envUrls(true);
    const baseMemberUrl = httpTools.envMemberUrls();
    const subApiUrl = httpTools.subApiUrl();

    return {
        getMe: token => {
            let defer = Q.defer();
            axios
                .get(`${baseUrl}/customers/me?expand=draftBankAccounts`, {
                    headers: {
                        Authorization: "Bearer " + token,
                        ...httpTools.getHeader()
                    }
                })
                .then(res => {
                    defer.resolve(res);
                })
                .catch(err => {
                    defer.reject(err);
                });
            return defer.promise;
        },
        getDistributorDetails: id => {
            if (call) {
                call.cancel("Only one request allowed at a time.");
            }
            call = axios.CancelToken.source();
            let defer = Q.defer();
            let getDistUrl = `${baseUrlLive}/customers.js?expand=customer,profilePicture&id.unicity=` + id;
            axios
                .get(getDistUrl, { cancelToken: call.token, headers: httpTools.getHeader() })
                .then(response => {
                    defer.resolve(response);
                })
                .catch(error => {
                    defer.reject(error);
                });
            return defer.promise;
        },
        checkEmailAddressExist: email => {
            let defer = Q.defer();
            let getDistUrl = `${baseUrl}/customers.js?_httpMethod=HEAD&email=` + encodeURIComponent(email);
            axios
                .get(getDistUrl, { headers: httpTools.getHeader() })
                .then(response => {
                    defer.resolve(response);
                })
                .catch(error => {
                    defer.reject(error);
                });
            return defer.promise;
        },
        checkGovernmentIdExist: (countryCode, govtId) => {
            let defer = Q.defer();
            let apiUrl = `${baseUrl}/customers.js?_httpMethod=HEAD&mainAddress_country=${countryCode}&taxTerms_taxId=${govtId}`;
            axios
                .get(apiUrl, { headers: httpTools.getHeader() })
                .then(response => {
                    defer.resolve(response);
                })
                .catch(error => {
                    defer.reject(error);
                });
            return defer.promise;
        },
        customerCreate: () => {
            const account = store.getState().form.account.values;
            const locale = store.getState().locale;
            let defer = Q.defer();
            let customerDetails = {
                humanName: {
                    firstName: account.firstName,
                    lastName: account.lastName
                },
                password: {
                    value: account.password
                },
                email: account.emailAddress,
                homePhone: account.phoneNumber,
                type: "Member",
                preferredLocale: locale.locale,
                mainAddress: {
                    country: Locale.getTranslationCountry(locale.country),
                    address1: "",
                    city: "",
                    zip: ""
                },
                source: {
                    agent: "Membership",
                    medium: getMedium(),
                    Platform: getOS()
                }
            };
            if (account.govId !== undefined) {
                customerDetails["taxTerms"] = {
                    taxId: account.govId
                };
            }
            if (account.sponsor !== undefined && account.sponsor !== null && account.sponsor !== "") {
                customerDetails["sponsor"] = {
                    href: `${subApiUrl}/customers?id.unicity=${account.sponsor}`
                };
                customerDetails["enroller"] = {
                    href: `${subApiUrl}/customers?id.unicity=${account.sponsor}`
                };
            } else {
                customerDetails["sponsor"] = {
                    href: `${subApiUrl}/customers?id.unicity=2`
                };
                customerDetails["enroller"] = {
                    href: `${subApiUrl}/customers?id.unicity=2`
                };
            }
            if (account.coapplicant !== undefined && account.coapplicant !== null && account.coapplicant !== "") {
                customerDetails["coapplicant"] = {
                    type: "Spouse",
                    details: {
                        humanName: {
                            firstName: account.coapplicant,
                            lastName: ""
                        }
                    }
                };
            }
            if (locale.country === "PR") {
                customerDetails["mainAddress"] = {
                    country: "US",
                    state: "Puerto Rico"
                };
            }
            //console.log(customerDetails);
            //return;
            let customerApi = `${baseUrl}/customers.js`;

            //console.log(customerDetails);
            let configs = {
                headers: {
                    "Content-Language": locale.locale,
                    "Accept-Language": locale.locale,
                    ...httpTools.getHeader()
                }
            };
            axios
                .post(customerApi, customerDetails, configs)
                .then(response => {
                    defer.resolve(response);
                })
                .catch(error => {
                    defer.reject(error);
                });

            return defer.promise;
        },
        customerCreateAccount: () => {
            const account = store.getState().form.account.values;
            const locale = store.getState().locale;
            let defer = Q.defer();

            let customerDetails = {
                sponsor_id: account.sponsor,
                firstname_english: account.firstName,
                lastname_english: account.lastName,
                email: account.emailAddress,
                phone: account.phoneNumber,
                password: account.password,
                agent: "Membership",
                medium: getMedium(),
                platform: getOS()
            };

            if (account.govId !== undefined) {
                customerDetails.tax_id = account.govId;
            }
            let customerApi = `${baseMemberUrl}/membership/validate/${locale.country}`;

            axios
                .post(customerApi, customerDetails, { headers: httpTools.getHeader() })
                .then(response => {
                    defer.resolve(response);
                })
                .catch(error => {
                    defer.reject(error.response);
                });

            return defer.promise;
        },

        customerCreateAccountHydra: () => {
            const account = store.getState().form.account.values;
            const cookies = new Cookies();
            const sponsor_id = cookies.get("refId") ? cookies.get("refId") : account.sponsor;
            const locale = store.getState().locale;

            const defer = Q.defer();
            const customerDetails = {
                mainAddress: {
                    country: Locale.getTranslationCountry(locale.country)
                },
                humanName: {
                    firstName: account.firstName.trim(),
                    lastName: account.lastName.trim()
                },
                enroller: sponsor_id
                    ? {
                          href: `${baseUrl}/customers?id.unicity=${sponsor_id.trim()}`,
                          href_params: [`id.unicity=${sponsor_id}`]
                      }
                    : undefined,
                sponsor: sponsor_id
                    ? {
                          href: `${baseUrl}/customers?id.unicity=${sponsor_id.trim()}`,
                          href_params: [`id.unicity=${sponsor_id.trim()}`]
                      }
                    : undefined,
                password: {
                    value: account.password.trim()
                },
                signature: {
                    value: "TS" // ??
                },
                email: account.emailAddress.trim(),
                [store.getState().locale.country === "HK" ? "homePhone" : "mobilePhone"]: account.phoneNumber.trim(),
                type: "Member",
                businessEntity: {
                    legalType: "SoleProprietorship"
                },
                source: {
                    agent: "Membership",
                    medium: getMedium(),
                    platform: getOS()
                },
                recaptchaToken: account.captchaToken
            };

            axios
                .post(`${baseUrl}/customers/`, customerDetails, { headers: httpTools.getHeader() })
                .then(response => {
                    defer.resolve(response);
                })
                .catch(error => {
                    defer.reject(error.response);
                });

            return defer.promise;
        },
        membershipValidate: (countryCode = store.getState().locale.country) => {
            const account = store.getState().form.account.values;

            const defer = Q.defer();
            const customerDetails = {
                tax_id: account.govId.trim(),
                sponsor_id: account.sponsor.trim(),
                fullname_native: account.fullName.trim(),
                firstname_english: account.firstName.trim(),
                lastname_english: account.lastName.trim(),
                email: account.emailAddress.trim(),
                phone: account.phoneNumber.trim(),
                password: account.password.trim(),
                agent: "Membership",
                medium: getMedium(),
                platform: getOS()
            };

            axios
                .post(`${baseMemberUrl}/membership/validate/${countryCode}?validate=1`, customerDetails, {
                    headers: httpTools.getHeader()
                })
                .then(response => {
                    defer.resolve(response);
                })
                .catch(error => {
                    defer.reject(error.response);
                });

            return defer.promise;
        },
        sendEmailWelcome: (email, fullName, member_id, url) => {
            // const account = store.getState().form.account.values
            const countryCode = store.getState().locale.country;
            const countryCode3 = store
                .getState()
                .locale.markets.filter(market => market.countryCode === countryCode)[0].countryCode3;

            let defer = Q.defer();

            const customerDetails = {
                to_email: email,
                register_name: fullName,
                member_id: member_id,
                shop_now_link: url
            };

            console.log("send Email Welcome success!");

            let sendEmailApi = `${baseMemberUrl}/email-api/email-membership/public/${countryCode3}/register`;
            axios
                .post(sendEmailApi, customerDetails, { headers: { "Content-Type": "application/json" } })
                .then(response => {
                    defer.resolve(response);
                })
                .catch(error => {
                    defer.reject(error.response);
                });

            return defer.promise;
        }
    };
})();

export default Customer;



// WEBPACK FOOTER //
// ./src/services/http/customer.js